import React from 'react'
import Footer from './Footer'
import GmaBanner from './GmaBanner'
import TopNav from './TopNav'

type PageLayoutProps = {
    children: React.ReactNode
    showGmaBanner?: boolean
}

const PageLayout: React.FC<PageLayoutProps> = ({ children, showGmaBanner = true }) => (
    <>
        <TopNav />
        <main className="site-main" id="main-content">{children}</main>
        {showGmaBanner && (
            <div className="container-fluid px-0">
                <GmaBanner />
            </div>
        )}
        <Footer />
    </>
)

export default PageLayout
